"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames_1 = require("classnames");
var icon_1 = require("../icon");
var ProgressTaskStatus;
(function (ProgressTaskStatus) {
    ProgressTaskStatus[ProgressTaskStatus["None"] = 0] = "None";
    ProgressTaskStatus[ProgressTaskStatus["InProgress"] = 1] = "InProgress";
    ProgressTaskStatus[ProgressTaskStatus["Done"] = 2] = "Done";
})(ProgressTaskStatus = exports.ProgressTaskStatus || (exports.ProgressTaskStatus = {}));
var ProgressTasks = /** @class */ (function (_super) {
    tslib_1.__extends(ProgressTasks, _super);
    function ProgressTasks(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.renderTask = _this.renderTask.bind(_this);
        return _this;
    }
    ProgressTasks.prototype.taskStatusClassFactory = function (status) {
        if (status === void 0) { status = ProgressTaskStatus.None; }
        var theme = this.props.theme;
        switch (status) {
            case ProgressTaskStatus.InProgress:
                return theme["status-in_progress"];
            case ProgressTaskStatus.Done:
                return theme["status-done"];
            default:
                return "";
        }
    };
    ProgressTasks.prototype.renderTask = function (task, index) {
        var _a;
        var _b = this.props, theme = _b.theme, onTaskClick = _b.onTaskClick, disableNone = _b.disableNone;
        var label = task.label, status = task.status, className = task.className;
        var classes = classnames_1.default(theme.task, className, this.taskStatusClassFactory(status), (_a = {},
            _a[theme.clickable] = !!onTaskClick && !(disableNone && status === ProgressTaskStatus.None),
            _a[theme["disable-none"]] = disableNone,
            _a));
        var onClick;
        if (onTaskClick && !(disableNone && status === ProgressTaskStatus.None)) {
            onClick = function () { return onTaskClick(task, index); };
        }
        return (React.createElement("li", { key: index, className: classes, onClick: onClick },
            React.createElement("div", { className: theme.dot }, status === ProgressTaskStatus.Done ? React.createElement(icon_1.Icon, { size: 1.2, iconName: "icon-v-small" }) : null),
            React.createElement("div", { className: theme.label }, label)));
    };
    ProgressTasks.prototype.render = function () {
        var _a = this.props, theme = _a.theme, className = _a.className, tasks = _a.tasks;
        if (!tasks.length) {
            return null;
        }
        var classes = classnames_1.default(theme["progress-tasks"], className);
        return (React.createElement("ul", { className: classes }, tasks.map(this.renderTask)));
    };
    ProgressTasks.defaultProps = {};
    return ProgressTasks;
}(React.Component));
exports.default = ProgressTasks;
